import { useCallback, useMemo, useState } from 'react';
import { getDefaultSessionState, SessionState } from '@/src/features/app/store/session/state';
import { ENV } from '@/src/.env';

export interface SessionStore {
  state: SessionState;

  update(duration: number): void;
  terminate(): void;
}

export const useSessionStore = (): SessionStore => {
  const [state, setState] = useState(getDefaultSessionState());

  const update = useCallback((milliseconds: number) => {
    const duration = milliseconds < 0 ? 0 : milliseconds;
    const seconds = Math.floor((duration / 1000) % 60);
    const minutes = Math.floor((duration / (60 * 1000)) % 60);

    setState(prevState => ({
      ...prevState,
      duration,
      time: `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
    }));
  }, []);

  const terminate = useCallback(() => {
    const redirect = encodeURIComponent(window.location.href);
    window.location.href = `${ENV.IDENTITY_URL}/login?redirect=${redirect}`;
  }, []);

  return useMemo(() => ({
    state,
    update,
    terminate,
  }), [
    state,
    update,
    terminate,
  ]);
};
